export default "__VITE_ASSET__EHyITan5__"